/**
 * reactOptions 포맷 {key}
 */
export const toMetricPanelFormat = (item) => {
    return { key: item.name };
};
/**
 * exportData 내부 metricList 포맷 {key, name, selected}
 */
export const fromMetricPanelFormat = (item) => {
    return {
        name: item.key,
        selected: true,
    };
};
/**
 * reactOptions 포맷 {key}
 */
export const toBreakdownPanelFormat = (item) => {
    return {
        key: item.id,
    };
};
/**
 * exportData 내부 breakdownList 포맷 {id, name, selected}
 */
export const fromBreakdownPanelFormat = (item) => {
    return {
        id: item.key,
        name: item.key,
        selected: true,
    };
};
